import { render } from "./MarketManagement.vue?vue&type=template&id=f4905fd2&scoped=true"
import script from "./MarketManagement.vue?vue&type=script&lang=js"
export * from "./MarketManagement.vue?vue&type=script&lang=js"

import "./MarketManagement.vue?vue&type=style&index=0&id=f4905fd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4905fd2"]])

export default __exports__